import angular from 'angular';
import 'components/sharpr/onOutsideClick/onOutsideClickDirective';
import headerAvatarComponent from './headerAvatarComponent';

angular
	.module('sh.headerAvatar', ['sh.onOutsideClick', 'sh.avatar'])
	.directive('shHeaderAvatar', headerAvatarComponent);
